import {Component, Inject, OnInit} from '@angular/core';
import { Localiser } from "../../../services/localiser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImagesService} from "../../../services/images.service";
import {UserService} from "../../../services/user.service";
import {subscribeToResult} from "rxjs/internal-compatibility";
import {imagen} from "../../../models/imagen";
import {luminaria} from "../../../models/luminaria";
import {imagenesModeloLuminaria} from "../../../models/imagenesModeloLuminaria";
import {ImagenesLuminariaService} from "../../../services/imagenes-luminaria.service";
import {ProyectoService} from "../../../services/proyecto.service";


@Component({
  selector: 'app-image-options',
  templateUrl: './image-options.component.html',
  styleUrls: ['./image-options.component.css']
})
export class ImageOptionsComponent implements OnInit {

  uploadImageView: boolean = false;
  previewImageBool: boolean = false;
  modelListView: boolean = false;
  modelView: boolean = false;
  deleteModeloView: boolean = false;

  imagesByEmpresa: imagen[] = [];
  imagenesModeloByEmpresa: imagenesModeloLuminaria[] = [];

  // Variables to upload images
  formData = new FormData();
  selectedFile: File = undefined;
  selectedPreviewImage: imagen = undefined;
  nameFile: string = undefined;
  nameOriginalFile: string = undefined;
  nameFileEmpty: boolean = false;
  uploadedImageUrl = undefined;

  // Variables to create or modify a model, or modify images of a lum
  idModelo: string = undefined;
  modeloNombre: string = "";
  modeloNombreEmpty: boolean = false;
  modeloIdEmpresa: string = "";
  imgOk: imagen = undefined;
  imgInactiv: imagen = undefined;
  imgErr: imagen = undefined;
  selectedImageToEdit: string = undefined;

  needToUpdate: boolean = false;
  connecting: boolean = false;
  deleteModeloVar: imagenesModeloLuminaria = undefined;


  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<ImageOptionsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {images: imagen[], modelos: imagenesModeloLuminaria[]},
              public imagesService: ImagesService, public user: UserService, public proyectoService: ProyectoService,
              public imagenesLuminariaService: ImagenesLuminariaService) { }

  ngOnInit(): void {
    this.imagesByEmpresa = this.data.images;
    this.imagenesModeloByEmpresa = this.data.modelos;
  }

  init() {
    this.getImagesByEmpresa();
    this.getImagenesModeloByEmpresa();
  }

  getImagesByEmpresa() {
    this.imagesService.getImagenesByEmpresa(this.proyectoService.getProyectoActual().idEmpresa).subscribe((result: imagen[]) => {
      this.imagesByEmpresa = result;
    })
  }

  getImagenesModeloByEmpresa() {
    this.imagenesLuminariaService.getModelosByIdEmpresa(this.proyectoService.getProyectoActual().idEmpresa).subscribe((result: imagenesModeloLuminaria[]) => {
      this.imagenesModeloByEmpresa = result;
    })
  }

  onSelectFile(event) {
    this.selectedFile = event.target.files[event.target.files.length - 1] as File;
    this.selectedPreviewImage = undefined;
    this.nameOriginalFile = event.target.files[event.target.files.length - 1].name;
    this.nameFile = event.target.files[event.target.files.length - 1].name.split('.').slice(0, -1).join('.');
    this.uploadedImageUrl = undefined;

    let reader = new FileReader();

    reader.readAsDataURL(this.selectedFile); // read file as data url

    reader.onload = (event) => { // called once readAsDataURL is completed
      this.uploadedImageUrl = event.target.result;
      this.previewImageBool = true;
    }

  }

  onClickPreviewImage(imagen: imagen) {
    this.selectedFile = undefined;
    this.selectedPreviewImage = imagen;
    this.nameOriginalFile = undefined;
    this.nameFile = imagen.nombre;
    this.uploadedImageUrl = imagen.rutaImagen;
    this.previewImageBool = true;
  }

  changeFileName() {
    this.nameFileEmpty = this.nameFile == "" || this.nameFile == undefined;
  }

  performUpload() {
    this.connecting = true;
    if (this.nameFile == "" || this.nameFile == null) {
      this.nameFileEmpty = true;
      this.connecting = false;
    } else if (this.selectedFile != undefined) {
      this.formData.set('file', this.selectedFile, this.selectedFile.name);
      this.imagesService.uploadImageForLuminarie(this.formData, this.user.getEmpresa()).subscribe(result => {
        this.connecting = false;
        this.init();
        this.needToUpdate = true;
      });
    } else {
      this.connecting = false;
    }
  }

  updateImageName() {
    this.connecting = true;
    if (this.nameFile == "" || this.nameFile == null) {
      this.connecting = false;
      this.nameFileEmpty = true;
    } else if (this.selectedPreviewImage != undefined) {
      this.imagesService.updateImageName(this.nameFile, this.selectedPreviewImage.nombre).subscribe(result => {
        this.connecting = false;
        this.init();
        this.needToUpdate = true;
      });
    } else {
      this.connecting = false;
    }
  }

  toHome() {
    this.modelListView = false;
    this.modelView = false;
    this.uploadImageView = false;
    this.deleteModeloView = false;
    this.outOfImageUpload();
  }

  toUploadImageView() {
    this.modelListView = false;
    this.modelView = false;
    this.uploadImageView = true;
    this.deleteModeloView = false;
    this.outOfImageUpload();
  }

  toModelListView() {
    this.modelListView = true;
    this.modelView = false;
    this.uploadImageView = false;
    this.deleteModeloView = false;
    this.outOfImageUpload();
  }

  toCreateModelo() {
    this.idModelo = undefined;
    this.modeloNombre = "";
    this.modeloIdEmpresa = this.proyectoService.getProyectoActual().idEmpresa;
    this.imgOk = undefined;
    this.imgInactiv  = undefined;
    this.imgErr = undefined;
    this.selectedImageToEdit = undefined;
    this.toModelView();
  }

  toEditModelo(idModelo) {
    let modelo: imagenesModeloLuminaria = this.imagenesModeloByEmpresa.find(modelo => modelo.idModelo == idModelo);
    if (modelo != undefined) {
      this.idModelo = modelo.idModelo;
      this.modeloNombre = modelo.nombre;
      this.modeloIdEmpresa = modelo.idEmpresa;
      this.imgOk = this.imagesByEmpresa.find(img => img.idImagen == modelo.imgOk);
      this.imgInactiv = this.imagesByEmpresa.find(img => img.idImagen == modelo.imgInactiv);
      this.imgErr = this.imagesByEmpresa.find(img => img.idImagen == modelo.imgErr);
      this.selectedImageToEdit = undefined;
    } else {
      this.toCreateModelo();
    }
    this.toModelView();
  }

  toModelView() {
    this.connecting = false;
    this.modelListView = false;
    this.modelView = true;
    this.uploadImageView = false;
    this.deleteModeloView = false;
    this.outOfImageUpload();
  }

  toDeleteModeloView(modelo: imagenesModeloLuminaria) {
    this.connecting = false;
    this.modelListView = false;
    this.modelView = false;
    this.uploadImageView = false;
    this.deleteModeloView = true;
    this.outOfImageUpload();
    this.deleteModeloVar = modelo;
  }

  outOfImageUpload() {
    this.previewImageBool = false;
    this.selectedFile = undefined;
    this.selectedPreviewImage = undefined;
  }

  selectImageToEdit(img) {
    if (img != this.selectedImageToEdit) {
      this.selectedImageToEdit = img;
    } else {
      this.selectedImageToEdit = undefined;
    }
  }

  selectImageToAddToModel(img: imagen) {
    if (this.selectedImageToEdit == "imgOk") {
      this.imgOk = img;
    } else if (this.selectedImageToEdit == "imgInactiv") {
      this.imgInactiv = img;
    } else if (this.selectedImageToEdit == "imgErr") {
      this.imgErr = img;
    }
  }

  deleteImageOfModel(img: string) {
    if (img == "imgOk") {
      this.imgOk = undefined;
    } else if (img == "imgInactiv") {
      this.imgInactiv = undefined;
    } else if (img == "imgErr") {
      this.imgErr = undefined;
    }
  }

  isImageSelected(img: imagen) {
    return (this.selectedImageToEdit == "imgOk" && img == this.imgOk) ||
      (this.selectedImageToEdit == "imgInactiv" && img == this.imgInactiv) ||
      (this.selectedImageToEdit == "imgErr" && img == this.imgErr);
  }

  saveModelo() {
    if (this.idModelo == undefined) {
      this.createModelo();
    } else {
      this.editModelo();
    }
  }

  createModelo() {
    this.connecting = true;
    this.modeloNombreEmpty = false;
    if (this.modeloNombre != "" && this.modeloNombre != undefined) {
      this.imagenesLuminariaService.newModelo(this.modeloNombre,
        (this.imgOk != undefined) ? this.imgOk.idImagen : "-1",
        (this.imgInactiv != undefined) ? this.imgInactiv.idImagen : "-1",
        (this.imgErr != undefined) ? this.imgErr.idImagen : "-1",
        this.modeloIdEmpresa).subscribe((result) => {
          this.idModelo = JSON.parse(result).idModelo;
          this.needToUpdate = true;
          this.connecting = false;
          this.init();
      });
    } else {
      this.modeloNombreEmpty = true;
      this.connecting = false;
    }
  }

  editModelo() {
    this.connecting = true;
    this.modeloNombreEmpty = false;
    if (this.modeloNombre != "" && this.modeloNombre != undefined) {
      this.imagenesLuminariaService.editModelo(this.idModelo, this.modeloNombre,
        (this.imgOk != undefined) ? this.imgOk.idImagen : "-1",
        (this.imgInactiv != undefined) ? this.imgInactiv.idImagen : "-1",
        (this.imgErr != undefined) ? this.imgErr.idImagen : "-1").subscribe(result => {
          this.init();
          this.needToUpdate = true;
          this.connecting = false;
      });
    } else {
      this.modeloNombreEmpty = true;
      this.connecting = false;
    }
  }

  getImgById(id) {
    return this.imagesByEmpresa.find(img => img.idImagen == id);
  }

  deleteModelo() {
    if (this.deleteModeloVar != undefined) {
      this.imagenesLuminariaService.deleteModelo(this.deleteModeloVar.idModelo).subscribe(result => {
        this.init();
        this.deleteModeloVar = undefined;
        this.toModelListView();
      });
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(this.needToUpdate);
  }

}
